
import { 
    ADD_ORGANIZATION,
    ADD_ORGANIZATION_SUCCESS,
    ADD_ORGANIZATION_FAIL, 
    ADD_ORGANIZATION_RESET,
} from "../actions/addOrganizationAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const addOrganizationReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_ORGANIZATION:
            return {
                ...state,
                apiState: "loading",
            };
        case ADD_ORGANIZATION_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case ADD_ORGANIZATION_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case ADD_ORGANIZATION_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default addOrganizationReducer;
